import { EmsSgReadyMode, EmsSgReadyStatus } from 'src/Libs/dynamic-power-prices/types'
import { EmsSgReadyStatusDTO } from '../api/sg-ready-status.api'

export const fromEmsSgReadyStatusDtoToModel = (dto: EmsSgReadyStatusDTO): EmsSgReadyStatus => {
  let sgReadyMode: EmsSgReadyMode | null
  switch (dto.state) {
    case 'STATE 1 BLOCK':
      sgReadyMode = EmsSgReadyMode.Blocked
      break
    case 'STATE 2 NORMAL':
      sgReadyMode = EmsSgReadyMode.Normal
      break
    case 'STATE 3 GO':
      sgReadyMode = EmsSgReadyMode.Recommended
      break
    case 'STATE 4 FORCE GO':
      sgReadyMode = EmsSgReadyMode.Forced
      break
    default:
      // Unknown / End
      sgReadyMode = null
      break
  }
  return { disabled: dto.disabled, state: sgReadyMode }
}
